module.exports = __webpack_public_path__ + "images/visibility-v2.png";